<template>
  <body>
    <form>
    <div class="containerb">
      <h1>Wählen Sie bitte einen Bereich aus.</h1>
    </div>
  </form>
  </body>
</template>

<script>
  export default {}
</script>

<style>

.containerb {
position: top;  
padding: 20px 20px;
margin-bottom: 50px;
margin-top: 50px;
}

</style>